import { makeStyles} from '@material-ui/core/styles';

const productCardStyles = makeStyles({
    root: {
      maxWidth: 370,
      margin:20,
    },
    price: {
      color:'#D32F2F',
      fontWeight:'bold'
    },
    cardButton:{
      fontWeight:'bold',
      textDecoration: 'none'
    }
  });

  export default productCardStyles;